import React from "react";
import TextInput from "./TextInput";

export default class AddressInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      addressLine1: this.props.addressLine1 || "",
      addressLine2: this.props.addressLine2 || "",
      city: this.props.city || "",
      state: this.props.state || "",
      zipCode: this.props.zipCode || "",
    };

    this.onChange = this.onChange.bind(this);
  }

  render() {
    return (
      <div className="AddressInput">
        <div className="row">
          <div className="col-sm-12">
            <TextInput
              name="addressLine1"
              value={this.state.addressLine1}
              placeholder="Address 1"
              onChange={this.onChange}
              // icon={
              //   <span
              //     className="fa fa-address-card"
              //     style={{ fontSize: 14 }}
              //   ></span>
              // }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <TextInput
              name="addressLine2"
              value={this.state.addressLine2}
              placeholder="Address 2"
              onChange={this.onChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <TextInput
              name="city"
              value={this.state.city}
              placeholder="City/Town"
              onChange={this.onChange}
              // icon={
              //   <span className="fa fa-map-marker" style={{ left: 15 }}></span>
              // }
            />
          </div>
          <div className="col-sm-3">
            {/* <Selectbox
              name="state"
              placeholder="State"
              value=""
              options={this.props.states}
              onChange={this.onChange}
            /> */}
            <TextInput
              name="state"
              value={this.state.state}
              placeholder="State"
              onChange={this.onChange}
              // icon={
              //   <span className="fa fa-map-marker" style={{ left: 15 }}></span>
              // }
            />
          </div>
          <div className="col-sm-3">
            <TextInput
              name="zipCode"
              value={this.state.zipCode}
              placeholder="Zip"
              onChange={this.onChange}
              // icon={
              //   <span className="fa fa-map-marker" style={{ left: 15 }}></span>
              // }
            />
          </div>
        </div>
      </div>
    );
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value }, () => {
      if (typeof this.props.onChange === "function") {
        this.props.onChange({
          target: {
            name: this.props.name,
            value: {
              addressLine1: this.state.addressLine1,
              addressLine2: this.state.addressLine2,
              city: this.state.city,
              state: this.state.state,
              zipCode: this.state.zipCode,
            },
          },
        });
      }
    });
  }
}
